import { SESSION_POLLING_STARTED, SESSION_POLLING_STOPPED, SESSION_STATUS_UPDATED, SESSION_ENDED_BY_THERAPIST, SESSION_STATUS_CHECK_FAILED } from './actionTypes';
/**
 * Action to start polling session status.
 *
 * @param {string} sessionId - The session ID to poll.
 * @param {number} pollInterval - The polling interval in milliseconds.
 * @returns {{
 *     type: SESSION_POLLING_STARTED,
 *     sessionId: string,
 *     pollInterval: number
 * }}
 */
export function startSessionPolling(sessionId, pollInterval) {
    return {
        type: SESSION_POLLING_STARTED,
        sessionId,
        pollInterval
    };
}
/**
 * Action to stop polling session status.
 *
 * @returns {{
 *     type: SESSION_POLLING_STOPPED
 * }}
 */
export function stopSessionPolling() {
    return {
        type: SESSION_POLLING_STOPPED
    };
}
/**
 * Action to update the session status.
 *
 * @param {string} sessionId - The session ID.
 * @param {string} status - The new status of the session.
 * @returns {{
 *     type: SESSION_STATUS_UPDATED,
 *     sessionId: string,
 *     status: string
 * }}
 */
export function updateSessionStatus(sessionId, status) {
    return {
        type: SESSION_STATUS_UPDATED,
        sessionId,
        status
    };
}
/**
 * Action indicating that the session has been ended by the therapist.
 *
 * @param {string} sessionId - The session ID.
 * @returns {{
 *     type: SESSION_ENDED_BY_THERAPIST,
 *     sessionId: string
 * }}
 */
export function sessionEndedByTherapist(sessionId) {
    return {
        type: SESSION_ENDED_BY_THERAPIST,
        sessionId
    };
}
/**
 * Action indicating that session status check failed.
 *
 * @param {Error} error - The error that occurred.
 * @returns {{
 *     type: SESSION_STATUS_CHECK_FAILED,
 *     error: Error
 * }}
 */
export function sessionStatusCheckFailed(error) {
    return {
        type: SESSION_STATUS_CHECK_FAILED,
        error
    };
}
